import React, { useState, useEffect } from 'react';

const VerticalBarLoader = ({ 
  barCount = 5, 
  height = 20, 
  width = 3, 
  color = '#3B82F6', 
  animationSpeed = 0.5 ,
  rotate = 0
}) => {
  const [activeBar, setActiveBar] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveBar((prev) => (prev + 1) % barCount);
    }, animationSpeed * 200);

    return () => clearInterval(interval);
  }, [barCount, animationSpeed]);

  return (
    <div 
      className="flex items-center justify-center space-x-2"
      style={{ height: `${height}px`,transform: `rotate(${rotate}deg)`,transformOrigin: 'center', }}
    >
      {[...Array(barCount)].map((_, index) => (
        <div
          key={index}
          className="transition-all duration-300 ease-in-out"
          style={{
            width: `${width}px`,
            height: `${height * (index === activeBar ? 1 : 0.3)}px`,
            backgroundColor: color,
            opacity: index === activeBar ? 1 : 0.3,
            borderRadius: '4px'
          }}
        />
      ))}
    </div>
  );
};

export default VerticalBarLoader;